// Libraries:
import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

// Components:
import LazyLoadImg from "core/LazyLoadImg";
import { ImageLink } from "./styles";

// Component:
const ItemsDisplay = ({ items, eachDataTestId, useRouterLink }) => {
    // only show up to 14 photos or icons:
    return items.slice(0, 14).map(item => {
        const { itemId, itemImage, itemTitle, itemDetailUrl } = item;
        const linkProps = useRouterLink
            ? {
                  as: Link,
                  to: itemDetailUrl
              }
            : {
                  as: "a",
                  href: itemDetailUrl
              };

        return (
            <ImageLink data-testid={eachDataTestId} key={itemId} {...linkProps}>
                <LazyLoadImg
                    key={itemId}
                    src={itemImage}
                    alt={itemTitle}
                    title={itemTitle}
                />
            </ImageLink>
        );
    });
};

ItemsDisplay.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            itemId: PropTypes.string.isRequired,
            itemTitle: PropTypes.string.isRequired,
            itemImage: PropTypes.string.isRequired
        })
    ),
    eachDataTestId: PropTypes.string,
    useRouterLink: PropTypes.bool
};

export default ItemsDisplay;
